var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "camaras",
      staticStyle: { height: "100%", width: "100%", "margin-top": "0.5%" }
    },
    [
      _c("MapComponent", {
        attrs: { openDialog: _vm.openDialog, event: _vm.currentEvent }
      }),
      _c(
        "div",
        { staticClass: "flex sm10 md10" },
        [
          _c(
            "FormFieldsContainer",
            [
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.fleets.label,
                          items: _vm.formFields.fleets.items,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: { input: _vm.handleFleet },
                        model: {
                          value: _vm.formFields.fleets.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.fleets, "value", $$v)
                          },
                          expression: "formFields.fleets.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("v-autocomplete", {
                        attrs: {
                          label: _vm.formFields.patents.label,
                          items: _vm.formFields.patents.items,
                          "item-text": "nombre",
                          "item-value": "id"
                        },
                        on: { input: _vm.handlePatent },
                        model: {
                          value: _vm.formFields.patents.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.patents, "value", $$v)
                          },
                          expression: "formFields.patents.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    [
                      _c("v-autocomplete", {
                        staticStyle: { width: "30vh" },
                        attrs: {
                          label: _vm.formFields.alerts.label,
                          items: _vm.formFields.alerts.items,
                          "item-text": "nombre",
                          "item-value": "id",
                          multiple: "",
                          chips: ""
                        },
                        on: { change: _vm.confirmAlerts },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend-item",
                            fn: function() {
                              return [
                                _c(
                                  "v-list-tile",
                                  [
                                    _c("v-checkbox", {
                                      attrs: { label: "Seleccionar todos" },
                                      on: {
                                        change: function($event) {
                                          return _vm.selectAllAlertas()
                                        }
                                      },
                                      model: {
                                        value: _vm.checkAllAlertas,
                                        callback: function($$v) {
                                          _vm.checkAllAlertas = $$v
                                        },
                                        expression: "checkAllAlertas"
                                      }
                                    })
                                  ],
                                  1
                                ),
                                _c("v-divider")
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "selection",
                            fn: function(ref) {
                              var item = ref.item
                              var index = ref.index
                              return [
                                index === 0
                                  ? _c("v-chip", [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(
                                            _vm.textoComprimido(item.nombre)
                                          )
                                        )
                                      ])
                                    ])
                                  : _vm._e(),
                                index === 1
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "grey--text text-caption",
                                        staticStyle: { "font-size": "0.75em" }
                                      },
                                      [
                                        _vm._v(
                                          "\n                (+" +
                                            _vm._s(
                                              _vm.formFields.alerts.value
                                                .length - 1
                                            ) +
                                            ")\n              "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]
                            }
                          }
                        ]),
                        model: {
                          value: _vm.formFields.alerts.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.alerts, "value", $$v)
                          },
                          expression: "formFields.alerts.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    {
                      staticStyle: { display: "flex", "align-items": "center" },
                      attrs: { sm3: "", md3: "" }
                    },
                    [
                      _c(
                        "v-btn",
                        { attrs: { icon: "" }, on: { click: _vm.handleClick } },
                        [_c("v-icon", [_vm._v("search")])],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-flex",
                { attrs: { sm12: "", md12: "", layout: "", wrap: "" } },
                [
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("DatePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.dateStart.label,
                          "data-vv-name": "fechaInicioRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaInicioRequerida"
                          ),
                          required: "",
                          min: _vm.fechaMinima,
                          max: _vm.fechaMaxima
                        },
                        model: {
                          value: _vm.formFields.dateStart.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateStart, "value", $$v)
                          },
                          expression: "formFields.dateStart.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("TimePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.timeStart.label,
                          "data-vv-name": "horaInicioRequerida",
                          "error-messages": _vm.errors.collect(
                            "horaInicioRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.timeStart.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.timeStart, "value", $$v)
                          },
                          expression: "formFields.timeStart.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("DatePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.dateEnd.label,
                          "data-vv-name": "fechaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "fechaFinRequerida"
                          ),
                          required: "",
                          min: _vm.fechaMinima,
                          max: _vm.fechaMaxima
                        },
                        model: {
                          value: _vm.formFields.dateEnd.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.dateEnd, "value", $$v)
                          },
                          expression: "formFields.dateEnd.value"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "v-flex",
                    { attrs: { sm2: "", md2: "" } },
                    [
                      _c("TimePicker", {
                        directives: [
                          {
                            name: "validate",
                            rawName: "v-validate",
                            value: "required",
                            expression: "'required'"
                          }
                        ],
                        attrs: {
                          label: _vm.formFields.timeEnd.label,
                          "data-vv-name": "horaFinRequerida",
                          "error-messages": _vm.errors.collect(
                            "horaFinRequerida"
                          ),
                          required: ""
                        },
                        model: {
                          value: _vm.formFields.timeEnd.value,
                          callback: function($$v) {
                            _vm.$set(_vm.formFields.timeEnd, "value", $$v)
                          },
                          expression: "formFields.timeEnd.value"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticStyle: { display: "flex" } },
        [
          _c(
            "v-btn",
            {
              attrs: {
                id: "btnExportCsv",
                flat: "",
                small: "",
                color: "primary"
              },
              on: { click: _vm.onBtnExport }
            },
            [
              _c("v-icon", { staticClass: "importExportBtnIcon" }, [
                _vm._v("cloud_download")
              ]),
              _vm._v("  \n      "),
              _c("span", { staticClass: "importExportBtnTexto" }, [
                _vm._v("Exportar"),
                _c("br"),
                _vm._v("CSV")
              ])
            ],
            1
          )
        ],
        1
      ),
      _c("WidgetAlerta", {
        attrs: { listaAlertasWidgets: _vm.listaAlertasWidgets },
        on: { filtroWidget: _vm.filtroWidget }
      }),
      _c(
        "v-card",
        { staticStyle: { width: "100%", "margin-top": "1%" } },
        [
          _c("GridComponent", {
            ref: "gridComponent",
            staticClass: "ag-theme-material",
            attrs: { id: "gridComponent", gridOptions: _vm.gridOptions }
          })
        ],
        1
      ),
      _vm.showReporteGenerado
        ? _c("div", { staticClass: "wrap-evidencia" }, [
            _c(
              "div",
              { staticClass: "modalEnvio", attrs: { id: "myModal2" } },
              [
                _c("div", { staticClass: "modalEnvio-content" }, [
                  _c(
                    "div",
                    [
                      _vm._m(0),
                      _c(
                        "div",
                        {
                          staticClass: "buttonClose buttonCloseEvidencia",
                          attrs: { align: "right" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: { flat: "", small: "", color: "primary" },
                              on: {
                                click: function($event) {
                                  return _vm.closeReporte()
                                }
                              }
                            },
                            [
                              _c(
                                "v-icon",
                                { staticClass: "importExportBtnIcon" },
                                [_vm._v("close")]
                              ),
                              _vm._v("  \n              "),
                              _c(
                                "span",
                                { staticClass: "importExportBtnTexto" },
                                [_vm._v("Cerrar")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c("v-flex", { attrs: { sm12: "", md12: "" } }, [
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c("p", { staticStyle: { "margin-top": "40px" } }, [
                            _vm._v(_vm._s(_vm.texto_reporte))
                          ])
                        ]),
                        _c("div", { staticClass: "text-sm-center" }, [
                          _c(
                            "p",
                            { staticStyle: { "margin-top": "40px" } },
                            [
                              _vm._v(
                                "\n                Puede ver sus reportes en el menú\n                "
                              ),
                              _c(
                                "router-link",
                                {
                                  staticStyle: {
                                    cursor: "pointer",
                                    "font-size": "13px"
                                  },
                                  attrs: {
                                    "active-class": "router-link-active",
                                    to: "/informe-generado-camaras"
                                  }
                                },
                                [_vm._v("Informes")]
                              )
                            ],
                            1
                          )
                        ])
                      ])
                    ],
                    1
                  )
                ])
              ]
            )
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "titleEvidencia" }, [
      _c("h2", { staticClass: "importExportBtnIcon" }, [
        _vm._v("Reporte Solicitado")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }